import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./navbar.css";
import { useAuth } from "../../context/auth";
import { AiFillHome } from "react-icons/ai";

const activeNavLink = {
  // borderBottom: "2px solid #00d2ff",
  color: "#00FFFF",
};

export const Navbar = () => {
  const {
    logout,
    loggedIn: isLoggedIn,
    setGameModePremium,
    setGameModeTrading,
    isPremiumMode,
    isTradingMode,
    isFreeMode,
    gameMode,
    getBalanceType,
    currentUser,
  } = useAuth();

  const [homeIconColor, setHomeIconColor] = useState("home");

  const [mouseStateIcon, setMouseStateIcon] = useState("cyan");

  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/") {
      console.log(location.pathname);
      setHomeIconColor("home");
    } else {
      console.log(location.pathname);
      setHomeIconColor("notHome");
    }
  }, [location.key]);

  return (
    <nav className="wrapper-navbar">
      <ul className="navbar-list">
        <li className="">
          <NavLink to={"/"}>
            {homeIconColor === "home" && (
              <AiFillHome size={28} color={"cyan"} />
            )}
            {homeIconColor === "notHome" && (
              <AiFillHome size={28} color={"#6666"} />
            )}
          </NavLink>
        </li>
        <li className="navbar-item">
          <NavLink
            to="/how-to-play"
            style={(state) => {
              return state.isActive ? activeNavLink : {};
            }}
          >
            How to play
          </NavLink>
        </li>
        <li className="navbar-item">
          <NavLink
            to="/cc-100-list"
            style={(state) => {
              return state.isActive ? activeNavLink : {};
            }}
          >
            CC 100 Index
          </NavLink>
        </li>
        <li className="navbar-item">
          <NavLink
            to="/ko-100"
            style={(state) => {
              return state.isActive ? activeNavLink : {};
            }}
          >
            Leaderboard
          </NavLink>
        </li>
        <li className="navbar-item">
          <div className="navbar_dropdown">
            {location.pathname.includes("account") ? (
              <p style={activeNavLink} className="dropdown_list_title">
                My Accounts
              </p>
            ) : (
              <p className="dropdown_list_title">My Accounts</p>
            )}

            <ul className="dropdown_list">
              <li>
                <NavLink to={"/account/trading"}>Trading Account</NavLink>
              </li>
              <li>
                <NavLink to="/account/premium">Premium Account</NavLink>
              </li>
              <li>
                <NavLink to="/account/plp">PLP</NavLink>
              </li>
              <li>
                <NavLink to={"/account/kotto"}>KOTTO A/C</NavLink>
              </li>
              <li>
                <NavLink to={"/account/profit-loss"}>Profit & Loss</NavLink>
              </li>
            </ul>
          </div>
        </li>
        <li className="navbar-item">
          <div className="navbar_dropdown">
            <NavLink
              to="/"
              className="dropdown_list_title"
              style={(state) => {
                return state.isActive ? activeNavLink : {};
              }}
            >
              {gameMode}
            </NavLink>

            {isLoggedIn && (isPremiumMode || isTradingMode) && (
              <ul className="dropdown_list">
                <li>
                  <NavLink
                    to="/"
                    onClick={setGameModeTrading}
                    style={{ color: isTradingMode ? "cyan" : "white" }}
                  >
                    Trading Account
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={"/"}
                    style={{ color: isPremiumMode ? "cyan" : "white" }}
                    onClick={setGameModePremium}
                  >
                    Premium Account
                  </NavLink>
                </li>
              </ul>
            )}
          </div>
        </li>
        <li className="navbar-item">
          <p>BAL: {getBalanceType()}</p>
          <p>
            {getBalanceType() === "CR" && isLoggedIn
              ? currentUser.user_game_status.cr_qty
              : "0.00"}
            {getBalanceType() === "DCR" && "100.00"}
            {getBalanceType() === "PCR" && "0.00"}
            {getBalanceType() === "TCR" && "0.00"}
          </p>
        </li>
        {!isLoggedIn ? (
          <>
            <li className="navbar-item join">
              <NavLink to="/join">Join</NavLink>
            </li>
            <li className="navbar-item login">
              <NavLink to="/login">Login</NavLink>
            </li>
          </>
        ) : (
          <>
            <li className="navbar-item user">
              <p>{currentUser.user_name}</p>
            </li>
            <li className="navbar-item logout">
              <button to="/join" onClick={logout}>
                Logout
              </button>
            </li>
          </>
        )}
      </ul>
    </nav>
  );
};
